import { render } from "./PriceServiceDetail.vue?vue&type=template&id=cd5d0be0&scoped=true&ts=true"
import script from "./PriceServiceDetail.vue?vue&type=script&lang=ts"
export * from "./PriceServiceDetail.vue?vue&type=script&lang=ts"

import "./PriceServiceDetail.vue?vue&type=style&index=0&id=cd5d0be0&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd5d0be0"]])

export default __exports__